import {Resource} from '@cquential/api';
import {PlanbordResource, ResourceWithKeyedByDateObjects} from '@/types/api-object-extensions';

export class ResourceUtil {
    public static displayName(resource: Resource | ResourceWithKeyedByDateObjects | PlanbordResource): string;
    public static displayName(resource: undefined | null): null;
    public static displayName(resource: Resource | ResourceWithKeyedByDateObjects | PlanbordResource | undefined | null): string | null;
    public static displayName(resource: Resource | ResourceWithKeyedByDateObjects | PlanbordResource | undefined | null): string | null {
        if (!resource) {
            return null;
        }

        return (resource.name + ' ' + (resource.nameAddendum ?? '')).trimEnd();
    }
}
